// Variable pour tracker si l'utilisateur doit être exclu des analytics
let isExcludedUser = false;
let currentUserEmail = null;

// Fonction pour initialiser la dataLayer
export const initDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
};

// Fonction pour définir l'email de l'utilisateur et vérifier s'il doit être exclu
export const setUserEmail = (email) => {
    currentUserEmail = email;
    // Exclure les adresses @sav-iol.com
    isExcludedUser = email && email.toLowerCase().endsWith('@sav-iol.com');
    
    // Pousser l'info dans dataLayer pour permettre aussi le filtrage côté GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'user_identified',
        userType: isExcludedUser ? 'internal' : 'external',
        userEmail: email
    });
    
    console.log(`Utilisateur ${isExcludedUser ? 'EXCLU' : 'INCLUS'} des analytics: ${email}`);
};

// Fonction pour obtenir le statut d'exclusion
export const isUserExcluded = () => isExcludedUser;

// Fonction pour envoyer un événement à GTM
export const pushEvent = (eventName, params = {}) => {
    if (!window.dataLayer) {
        console.warn('dataLayer n\'est pas initialisé');
        return;
    }

    // Bloquer les événements pour les utilisateurs internes @sav-iol.com
    if (isExcludedUser) {
        console.log(`🚫 Événement analytics bloqué (utilisateur interne @sav-iol.com): ${eventName}`, params);
        return;
    }

    window.dataLayer.push({
        event: eventName,
        ...params
    });

    console.log(`✅ Événement envoyé à GTM: ${eventName}`, params);
};

// Événements spécifiques basés sur le CSV
export const triggerMainNav = (section) => {
    pushEvent('main_nav', { section });
};

export const triggerSubNav = (section, chapter) => {
    pushEvent('sub_nav', { section, chapter });
};

export const triggerSubNavAction = (section, chapter, action, part = null) => {
    const params = { section, chapter, action };
    if (part) {
        params.part = part;
    }
    pushEvent('sub_nav_action', params);
};

// Fonction pour suivre les vues de page
export const trackPageView = (path) => {
    pushEvent('page_view', { page_path: path });
}; 